import { IItemGroupSelectBehavior } from "./IItemGroupSelectBehavior";

export interface IItemGroupSelectBehaviorSpecifiable {
  itemGroupSelectBehavior: IItemGroupSelectBehavior;
}

export function instanceOfIItemGroupSelectBehaviorSpecifiable(instance: any): instance is IItemGroupSelectBehaviorSpecifiable {
  return instance
    && (instance.itemGroupSelectBehavior !== undefined);
}
